import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Calendar, TrendingUp, Target, Award, Users, BarChart } from 'lucide-react';

const ResponsibleNews = () => {
  return (
    <div className="min-h-screen bg-book-cream">
      <Header />
      <main className="book-section">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <div className="flex items-center justify-center space-x-2 mb-4">
              <Calendar className="h-6 w-6 text-book-brown" />
              <span className="text-book-brown-dark font-medium">02.12.2025</span>
              <span className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-medium">Responsible Gaming</span>
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-book-brown mb-6">
              Responsible Gambling Initiatives Reach New Heights in UK
            </h1>
            <p className="text-xl text-book-brown-dark leading-relaxed">
              Industry-leading operators implement AI-powered monitoring systems and personalized intervention strategies
              to enhance player protection.
            </p>
          </div>

          <div className="mb-12 bg-gradient-to-br from-book-brown to-book-brown-light rounded-xl p-8 text-center text-book-cream">
            <TrendingUp className="h-16 w-16 mx-auto mb-4 opacity-80" />
            <img
              src="/images/nathana-reboucas-1riTdO9dW3c-unsplash.webp"
              alt="Responsible Gaming AI"
              className="w-full h-64 object-cover rounded-lg"
            />
            <p className="text-sm opacity-75">AI-Powered Player Protection</p>
          </div>

          <div className="mb-16 bg-book-beige rounded-xl p-8 shadow-book-inset">
            <h2 className="text-2xl font-bold text-book-brown mb-6 text-center">Our News Curation Philosophy</h2>
            <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
              <p>Every guide published on Brit Ember represents extensive research and deep industry insights...</p>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-6">AI-Driven Player Protection Revolution</h2>
            <p>The integration of artificial intelligence into responsible gambling frameworks marks a paradigm shift...</p>
          </div>

          <div className="mb-12">
            <h2 className="text-3xl font-bold text-book-brown mb-8 text-center">Responsible Gaming Enhancement Metrics</h2>
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">AI Intervention Success</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Early Detection</span>
                    <span className="font-semibold text-green-600">94%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Preventive Actions</span>
                    <span className="font-semibold text-green-600">87%</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-book-brown-dark">Player Retention</span>
                    <span className="font-semibold text-blue-600">78%</span>
                  </div>
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Personalization Effectiveness</h3>
                <div className="flex justify-center mb-4">
                  <div className="relative w-48 h-48">
                    <svg viewBox="0 0 100 100" className="w-full h-full">
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#FFD700" strokeWidth="20"/>
                      <circle cx="50" cy="50" r="40" fill="none" stroke="#228B22" strokeWidth="20" strokeDasharray="125.66" strokeDashoffset="31.42"/>
                    </svg>
                    <div className="absolute inset-0 flex items-center justify-center">
                      <span className="text-2xl font-bold text-book-brown">91%</span>
                    </div>
                  </div>
                </div>
                <div className="text-center text-sm text-book-brown-dark">
                  Accuracy in risk assessment
                </div>
              </div>
              <div className="bg-white rounded-xl shadow-book p-6">
                <h3 className="text-xl font-bold text-book-brown mb-4 text-center">Support System Efficiency</h3>
                <div className="space-y-4">
                  <div className="space-y-3">
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">24/7 Availability</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-green-500 h-3 rounded-full" style={{width: '100%'}}></div>
                      </div>
                      <span className="font-semibold text-green-600">100%</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">Response Time</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-green-500 h-3 rounded-full" style={{width: '95%'}}></div>
                      </div>
                      <span className="font-semibold text-green-600">&lt;2 min</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-book-brown-dark">Resolution Rate</span>
                      <div className="flex-1 mx-4 bg-gray-200 rounded-full h-3">
                        <div className="bg-blue-500 h-3 rounded-full" style={{width: '88%'}}></div>
                      </div>
                      <span className="font-semibold text-blue-600">88%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="prose prose-lg max-w-none text-book-brown-dark leading-relaxed">
            <p>The integration of artificial intelligence into responsible gambling frameworks marks a paradigm shift...</p>
            <div className="bg-book-beige rounded-lg p-6 my-8">
              <h4 className="text-xl font-bold text-book-brown mb-4">AI-Powered Protection Features</h4>
              <ul className="space-y-2">
                <li className="flex items-start">
                  <Target className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Real-time behavioral analysis and risk pattern detection</span>
                </li>
                <li className="flex items-start">
                  <Award className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Personalized intervention strategies and support recommendations</span>
                </li>
                <li className="flex items-start">
                  <Users className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Automated self-exclusion triggers and cooling-off periods</span>
                </li>
                <li className="flex items-start">
                  <BarChart className="h-5 w-5 text-book-brown mr-3 mt-0.5 flex-shrink-0" />
                  <span>Predictive analytics for early problem gambling identification</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ResponsibleNews;
